import React from 'react'

import SearchIcon from '../../i/icons/search.svg';

export const SearchStreams = ({
	handleSubmit,
	handleOnChange,
	searchInputValue,
	searchInputError,
	inputPlaceHolderValue,
	formNote
}) => {
	return (
		<div className="search_streams">
			<div className="search_streams_field">
				<form onSubmit={handleSubmit}>
					<dl className="form_cell form_cell_v1_mod">
						<dt className="form_cell_title form_v2_mod hline_hide_mod">
							<label htmlFor="search_stream">search_stream</label>
						</dt>
						<dd className="form_field_wrap form_v2_mod hline_hide_mod">
							<input
								className="form_field default_mod search_mod"
								type="text"
								id="search_stream"
								placeholder={inputPlaceHolderValue}
								onChange={handleOnChange}
								value={searchInputValue}
							/>
						</dd>
					</dl>
					<button className="search_streams_button">
						<SearchIcon className="icon icon-search search_mod size_mod white_mod" />
					</button>
				</form>
			</div>
	<span className="search_streams_note">{formNote}</span>
			{searchInputError ? <div className="error_message">{searchInputError}</div> : null}
		</div>
	);
}
export default SearchStreams;